import { useEffect, useState } from "react";

import { getJourneyCapabilities } from "./journeyApi";


const CLOSED = Object.freeze({
  unified_journeys_enabled: false,
  my_journeys_enabled: false,
  reviews_enabled: false,
  disputes_enabled: false,
});

export default function useJourneyCapabilities() {
  const [state, setState] = useState({ status: "loading", capabilities: CLOSED });

  useEffect(() => {
    let active = true;
    getJourneyCapabilities()
      .then((capabilities) => {
        if (active) setState({ status: "ready", capabilities: { ...CLOSED, ...capabilities } });
      })
      .catch(() => {
        if (active) setState({ status: "error", capabilities: CLOSED });
      });
    return () => { active = false; };
  }, []);

  return state;
}
